<div class="vertical-tabs edit-content" >
  <div class="nav flex-column nav-pills nav-pills-custom">
    @for (tab of tabs; track tab) {
      <a [ngClass]="'nav-link p-3 ' + (tab.customCss || '')" [class.active]="tab.selected" (click)="selectTab(tab)">
        @if (tab.faIcon) {
          <i [class]="tab.faIcon + ' me-2'"></i>
        }
        <span class="fw-bold small text-uppercase">{{tab.tabTitle | translate}}</span>
      </a>
    }
  </div>
</div>

<ng-content></ng-content>
